import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { htmlToMarkdown, Shell } from '@tytapp/common';
import { ContentBlock } from './content-block';

@Component({
    selector: 'tyt-default-content',
    template: `
        <tyt-content-customizable-c2a
            [pageTitle]="title"
            [url]="url"
            [description]="description"
            [summary]="summary"
            [blocks]="blocks"
            [includeInSearch]="includeInSearch"
            />
        <div #content>
            <ng-content />
        </div>
    `,
    styles: ``
})
export class DefaultContentComponent {
    private shell = inject(Shell);
    @Input({ required: true }) url: string;
    @Input({ required: true }) description: string;
    @Input({ required: true }) summary: string;
    @Input({ required: true }) includeInSearch: boolean;

    @ViewChild('content')
    contentElementRef: ElementRef<HTMLDivElement>;

    blocks: ContentBlock[] = [];

    get title() {
        return this.shell.title;
    }

    ngAfterViewInit() {
        let html = this.contentElementRef.nativeElement.innerHTML;
        let markdown = htmlToMarkdown(html);

        console.log(`this: ${markdown}`);

        setTimeout(() => {
            this.blocks = [
                <any>{
                    type: 'text',
                    body: markdown,
                    format: 'markdown'
                }
            ];
        })

    }

    ngAfterContentInit() {
    }
}